import MessageInput from './MessageInput';

export default MessageInput;
